import { FetchResult, Operation } from '@apollo/client'
import { GQLErrorExtensions } from '../interface'

export const MAX_REFRESH_RETRIES = 1

export const hasUnauthenticatedGQLError = (result: FetchResult) =>
  !!result.errors?.some(
    (e) =>
      (e.extensions as GQLErrorExtensions)?.code === 'UNAUTHENTICATED' ||
      /UNAUTHENTICATED|UNAUTHORIZED/i.test(e.message ?? '')
  )

export const updateAuthHeader = ({
  operation,
  token,
}: {
  operation: Operation
  token: string
}) => {
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      token,
    },
  }))
}
